import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { TenantId } from '@app/enums/TenantId';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  readonly edgeCommunicationAssessmentId = environment.edgeAssessments.communication.id;
  readonly edgeCommuunicationAssessmentUrl = environment.edgeAssessments.communication.url;

  readonly edgeBehavioralAssessmentId = environment.edgeAssessments.behavioral.id;
  readonly edgeBehavioralAssessmentUrl = environment.edgeAssessments.behavioral.url;

  readonly segmentWriteKey = environment.segmentWriteKey;

//Get the communication assessment URL based on tenant.
  
  getCommunicationAssessmentUrl(tenantId?: string): string {
    return this.getTenantAwareUrl(this.edgeCommuunicationAssessmentUrl, tenantId);
  }

  // Get the behavioral assessment URL based on tenant.
  getBehavioralAssessmentUrl(tenantId?: string): string {
    return this.getTenantAwareUrl(this.edgeBehavioralAssessmentUrl, tenantId);
  }

  private getTenantAwareUrl(baseUrl: string, tenantId?: string): string {
    if (tenantId === TenantId.CSU) {
      return baseUrl.replace('/c35c/', '/csu/');
    }
    if (tenantId === TenantId.CSU_MOCK) {
      return baseUrl.replace('/c35c/', '/csu-mock/');
    }
    if (tenantId === TenantId.BRANDEIS) {
      return baseUrl.replace('/c35c/', '/brandeis/');
    }
    if (tenantId === TenantId.BRANDEIS_MOCK) {
      return baseUrl.replace('/c35c/', '/brandeis-mock/');
    }
    if (tenantId === TenantId.AU) {
      return baseUrl.replace('/c35c/', '/au/');
    }
    if (tenantId === TenantId.AU_MOCK) {
      return baseUrl.replace('/c35c/', '/au-mock/');
    }
    return baseUrl;
  }
}
